import React from 'react'
import { NotFoundTpl } from '../../../components/templates'
import { Meta } from '../../../Meta'

export const NotFound: React.FC = () => {
  return (
    <>
      <Meta title="ページが見つかりませんでした" noindex />
      <NotFoundTpl />
    </>
  )
}
